// extracted by mini-css-extract-plugin
module.exports = {"formSection":"styles_formSection__hUP91","header":"styles_header__V4x3R","icon":"styles_icon__LWJPm"};